// extracted by mini-css-extract-plugin
export default {"accordionWrap":"SimpleAccordion_accordionWrap__dsNFy","accordionHeader":"SimpleAccordion_accordionHeader__D8cgL"};